// Descriptor aliases for recurring series.
//
// When a bank changes how a charge is described ("NETFLIX.COM" becomes
// "NETFLIX INC"), the new descriptor keys to a different series and the real
// one reads as missed. Linking one such charge (missed.js) records its natural
// key as an alias of the series, at users/{uid}/seriesLifecycle/{key}/aliases.
// Every later charge under that descriptor then joins the series on import —
// in the web app's auto-attach and in the sync pipeline alike.
//
// Kept apart from missed.js so the sync pipeline can import it without pulling
// in the runway and variance modules.

import { seriesKeyOf } from './series-key.js';
import { firebaseSafeKey } from '../firebaseKey.js';

/** A transaction's key from its descriptor alone, ignoring any stored override. */
export const naturalSeriesKeyOf = (tx) => seriesKeyOf({ description: tx.description, type: tx.type });

/** firebaseSafeKey(natural key) → series key, across every series' aliases. */
export function seriesAliasMap(lifecycle = {}) {
  const out = {};
  Object.values(lifecycle || {}).forEach((entry) => {
    if (!entry || !entry.seriesKey || !entry.aliases) return;
    Object.entries(entry.aliases).forEach(([alias, on]) => {
      if (on) out[alias] = entry.seriesKey;
    });
  });
  return out;
}

/** The series a transaction's descriptor has been aliased to, if any. */
export function aliasedSeriesKey(tx, aliasMap = {}) {
  return aliasMap[firebaseSafeKey(naturalSeriesKeyOf(tx))] || null;
}
